<template lang="html">
  <div id="neighbourhood-list" class="contained-height">
    <scrollable-content>
      <template>
        <transition-group name="row-animate" tag="div" class="pt-4"
        id="neighbourhood-poi-list" ref="poiList">
        <div v-for="poi in poiList" :key="poi.id"
        class="neighbourhood-poi
        d-flex align-items-end justify-content-between
        py-3 px-3 row-animate-item m-auto"
        :class="{ 'selected-poi': poi.id === selectedPoiId }"
        @click="selectPoi(poi)"
        ref="poi">
        <div class="d-flex align-items-end">
          <div class="poi-id mr-4">
            {{ poi.orderId }}
          </div>
          <div>
            <div class="poi-hint">
              <span>{{ poi.type }}</span>
            </div>
            <div class="poi-name" v-html="poi.name" />
          </div>
        </div>
        <div class="d-flex">
          <div v-if="deviceLg || travelMode === 'walk'"
          class="poi-traveltime
          d-flex align-items-center justify-content-end">
          <i class="far fa-walking mr-1"></i>
          <div class="text-center">
            <div class="poi-traveltime-number">
              {{ poi.travelTime.walk }}
            </div>
            <div class="poi-traveltime-min">min</div>
          </div>
        </div>
        <div v-if="deviceLg || travelMode === 'transit'"
        class="poi-traveltime
        d-flex align-items-center justify-content-end">
        <i class="fas fa-bus mr-1"></i>
        <div class="text-center">
          <div class="poi-traveltime-number">
            {{ poi.travelTime.transit }}
          </div>
          <div class="poi-traveltime-min">min</div>
        </div>
      </div>
      <div v-if="deviceLg || travelMode === 'drive'"
      class="poi-traveltime
      d-flex align-items-center justify-content-end">
      <i class="fas fa-car mr-1"></i>
      <div class="text-center">
        <div class="poi-traveltime-number">
          {{ poi.travelTime.drive }}
        </div>
        <div class="poi-traveltime-min">min</div>
      </div>
    </div>
  </div>
</div>
</transition-group>
</template>
    </scrollable-content>
    <neighbourhood-list-actions />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import ScrollableContentComponent from '@/components/ScrollableContent';
import NeighbourhoodListActions from './NeighbourhoodListActions';

export default {
  name: 'neighbourhood-list',
  props: {
    poiList: {
      type: Array,
      default: () => []
    },
    selectedPoiId: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      travelMode: state => state.neighbourhood.travelMode
    }),
    ...mapGetters({
      deviceLg: 'ui/deviceLg'
    })
  },
  methods: {
    selectPoi(poi) {
      this.$emit('setSelectedPoiId', poi.id);
    },
    scrollTo(element, to, duration) {
      if (duration <= 0) return;
      const difference = to - element.scrollTop;
      const perTick = difference / duration * 10;

      setTimeout(() => {
        element.scrollTop += perTick;
        if (element.scrollTop === to) return;
        this.scrollTo(element, to, duration - 10);
      }, 10, this);
    }
  },
  watch: {
    selectedPoiId() {
      const poiIndex = this.poiList.indexOf(
        this.poiList.find(poi => poi.id === this.selectedPoiId)
      );

      this.scrollTo(this.$refs.poiList.$el.parentElement,
        this.$refs.poi[poiIndex].offsetTop, 200);
    },
    poiList() {
      this.scrollTo(this.$refs.poiList.$el.parentElement, 0, 200);
    }
  },
  components: {
    'neighbourhood-list-actions': NeighbourhoodListActions,
    'scrollable-content': ScrollableContentComponent
  }
};
</script>

<style lang="scss" scoped>
#neighbourhood-list {
  padding-bottom: $action-bar-height;
  background-color: var(--background);
}

.neighbourhood-poi {
  text-align: left;
  line-height: 1;
  max-width: 700px;
  color: var(--text);
  border-radius: .25rem!important;
  background-color: var(--background);

  &:hover {
    cursor: pointer;
    background-color: var(--highlight);
  }
}

.poi-id {
  font-size: 1.6rem;
  text-align: left;
  width: 20px;
  color: var(--branding);
}

.poi-traveltime {
  text-align: right;
  width: 3.4rem;

  .fa-car, .fa-bus, .fa-walking {
    font-size: 1rem;
  }
}

.poi-traveltime-number {
  font-size: 1.2rem;
  line-height: 0.6;
  color: var(--text-dark);
  font-family: Scandia-Regular, sans-serif;
}

.poi-traveltime-min {
  font-size: 0.7rem;
}

.poi-hint {
  text-transform: uppercase;
  font-size: 0.8rem;

  span {
    font-family: Scandia-Medium;
    letter-spacing: 1px;
  }
}

.poi-name {
  font-size: 1.2rem;
  color: black;
  font-family: Scandia-Regular, sans-serif;
}

.selected-poi {
  background: var(--action);
  color: white;

  &:hover {
    background: var(--action);
  }

  .poi-name, .poi-traveltime-number {
    color: white;
  }

  .poi-id {
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/NeighbourhoodPage/NeighbourhoodMap/NeighbourhoodList.vue